import { useMemo } from "react";
import { useDataStore } from "@store/user_org";
import { useRatedOrdres } from "./useRatedOrdres";
import { navigateTo } from "context/navigation.service";

export default function ClientSatisfactionWidget() {
  const orgId = useDataStore((s) => s.orgData?.id);
  const { ordres: rated } = useRatedOrdres(orgId);

  const ratingStats = useMemo(() => {
    if (rated.length === 0) return null;
    const avg = rated.reduce((sum, o) => sum + (o.client_rating || 0), 0) / rated.length;
    const lowRatings = rated.filter((o) => (o.client_rating || 0) <= 2).slice(0, 3);
    return { avg: Math.round(avg * 10) / 10, count: rated.length, lowRatings };
  }, [rated]);

  if (!ratingStats) {
    return (
      <div className="flex flex-col bg-white border rounded-xl p-4 gap-3 shadow-lg">
        <div className="font-semibold text-black">Satisfaction client</div>
        <div className="text-h3 text-neutral-400 py-2">Aucun avis pour le moment</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col bg-white border rounded-xl p-4 gap-3 shadow-lg">
      <div className="flex flex-row justify-between items-center">
        <div className="font-semibold text-black">Satisfaction client</div>
        <button
          onClick={() => navigateTo({ route: "/settings?page=avis" })}
          className="text-h3 text-neutral-400 hover:text-neutral-600"
        >
          Voir tout
        </button>
      </div>
      <div className="flex flex-row items-center gap-3">
        <div className="flex flex-col items-center justify-center w-16 h-16 rounded-xl" style={{ background: ratingStats.avg >= 4 ? "#F0FDF4" : ratingStats.avg >= 3 ? "#FFFBEB" : "#FEF2F2" }}>
          <span className="text-xl font-bold" style={{ color: ratingStats.avg >= 4 ? "#22C55E" : ratingStats.avg >= 3 ? "#F59E0B" : "#EF4444" }}>{ratingStats.avg}</span>
          <div className="flex gap-0.5">
            {[1, 2, 3, 4, 5].map((s) => (
              <svg key={s} width="8" height="8" viewBox="0 0 24 24" fill={s <= Math.round(ratingStats.avg) ? (ratingStats.avg >= 4 ? "#22C55E" : ratingStats.avg >= 3 ? "#F59E0B" : "#EF4444") : "#E5E5E5"}>
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
            ))}
          </div>
        </div>
        <div className="flex flex-col">
          <span className="text-h2 font-medium text-black">{ratingStats.count} avis</span>
          <span className="text-h3 text-neutral-400">ce mois</span>
        </div>
      </div>
      {ratingStats.lowRatings.length > 0 && (
        <div className="flex flex-col gap-1 border-t pt-2">
          <span className="text-h4 text-neutral-400">Avis négatifs récents</span>
          {ratingStats.lowRatings.map((o) => (
            <div
              key={o.id}
              className="flex flex-row items-center justify-between py-1 px-1 rounded hover:bg-neutral-50 cursor-pointer"
              onClick={() => navigateTo({ route: `/ordre/${o.id}` })}
            >
              <span className="text-h3 text-black">{o.name}</span>
              <div className="flex gap-0.5">
                {[1, 2, 3, 4, 5].map((s) => (
                  <svg key={s} width="10" height="10" viewBox="0 0 24 24" fill={s <= (o.client_rating || 0) ? "#EF4444" : "#E5E5E5"}>
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
